import { SERVICES } from "@/lib/media";
import { Reveal, TiltCard, ImageReveal, RevealWords } from "./Reveal";

export default function Services() {
  return (
    <section id="services" className="relative bg-ink py-24 md:py-40 border-t border-white/10" data-testid="services">
      <div className="max-w-[1500px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <Reveal>
              <span className="font-serif italic text-gold tracking-[0.25em] text-sm">What We Inspect</span>
            </Reveal>
            <h2 className="font-display uppercase text-cream leading-[0.9] tracking-tight text-5xl md:text-7xl mt-4">
              <RevealWords text="Every Inch" highlight={[1]} />
            </h2>
          </div>
          <Reveal delay={0.1}>
            <p className="text-cream/60 max-w-sm leading-relaxed">
              Our inspections are performed by certified professionals utilizing thermal-imaging and
              drone technology.
            </p>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-2 gap-5">
          {SERVICES.map((s, i) => (
            <Reveal key={s.id} delay={i * 0.08}>
              <TiltCard
                className="group relative overflow-hidden border border-white/10 bg-surface h-[420px] flex flex-col justify-end transition-colors duration-500 hover:border-gold/40"
                data-testid={`service-card-${s.id}`}
              >
                <div className="absolute inset-0">
                  <ImageReveal
                    src={s.image}
                    alt={s.title}
                    className="w-full h-full"
                    imgClass="opacity-100 group-hover:scale-105 transition-transform duration-[900ms]"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/25 to-transparent" />
                </div>

                <div className="relative z-10 p-8 md:p-10">
                  <div className="flex items-center justify-between mb-4">
                    <span className="font-display text-gold/50 text-5xl group-hover:text-gold transition-colors duration-500">
                      {s.num}
                    </span>
                    <span className="font-serif italic text-gold text-sm tracking-wider">{s.tag}</span>
                  </div>
                  <h3 className="font-display uppercase text-cream text-3xl md:text-4xl tracking-tight">
                    {s.title}
                  </h3>
                  <p className="text-cream/60 mt-3 leading-relaxed max-w-md">{s.desc}</p>
                  <div className="mt-6 h-px w-0 group-hover:w-full bg-gold transition-all duration-700" />
                </div>
              </TiltCard>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
